import {
    getProperties,
    deleteProperty,
    createProperty,
    updateProperty,
    getPropertyFilters,
    getProperty,
    getReportedAds,
    getReportProperties
} from '../../../services/PropertyService';
import {
    CONFIRMED_GET_PROERTIES,
    CONFIRMED_GET_FILTERS,
    CONFIRMED_GET_PROPERTY,
    CONFIRMED_GET_REPORTED_ADS
} from './PropertyTypes';

export function getPropertiesAction(currentPage, pageSize, searchTerm, filterQuery) {
    return (dispatch, getState) => {
        dispatch({ type: 'SET_PROPERTY_LOADING', payload: true });
        // dispatch(confirmedGetPropertiesAction([]));
        getProperties(currentPage, pageSize, searchTerm, filterQuery)
            .then((response) => {
                dispatch(confirmedGetPropertiesAction(response.data.data));
            })
            .finally(() => {
                dispatch({ type: 'SET_PROPERTY_LOADING', payload: false });
            });
    };
}

export function confirmedGetPropertiesAction(data) {
    return {
        type: CONFIRMED_GET_PROERTIES,
        payload: data,
    };
}

export function getPropertyAction(id, populate) {
    return (dispatch, getState) => {
        dispatch({ type: 'SET_PROPERTY_LOADING', payload: true });
        dispatch(confirmedGetPropertyAction([]));
        getProperty(id, populate)
            .then((response) => {
                dispatch(confirmedGetPropertyAction(response.data.data));
            })
            .finally(() => {
                dispatch({ type: 'SET_PROPERTY_LOADING', payload: false });
            });
    };
}

export function confirmedGetPropertyAction(data) {
    return {
        type: CONFIRMED_GET_PROPERTY,
        payload: data,
    };
}

export function deletePropertyAction(id, history) {
    return (dispatch, getState) => {
        return deleteProperty(id).then((response) => {
            return response;
        });
    };
}

export function createPropertyAction(data) {
    return () => {
        return createProperty(data).then((response) => {
            return response;
        });
    };
}

export function updatePropertyAction(id, data) {
    return () => {
        return updateProperty(id, data).then((response) => {
            return response;
        });
    };
}

export function getPropertyFiltersAction() {
    return (dispatch, getState) => {
        getPropertyFilters().then((response) => {
            dispatch(confirmedGetFiltersAction(response.data));
        });
    };
}

export function confirmedGetFiltersAction(data) {
    return {
        type: CONFIRMED_GET_FILTERS,
        payload: data,
    };
}

export function getReportedAdsAction(currentPage, pageSize, searchTerm, filterQuery) {
    return (dispatch, getState) => {
        dispatch({ type: 'SET_PROPERTY_LOADING', payload: true });
        getReportedAds(currentPage, pageSize, searchTerm, filterQuery)
            .then((response) => {
                dispatch(confirmedGetReportedAction(response.data.data));
            })
            .finally(() => {
                dispatch({ type: 'SET_PROPERTY_LOADING', payload: false });
            });
    };
}

export function confirmedGetReportedAction(data) {
    return {
        type: CONFIRMED_GET_REPORTED_ADS,
        payload: data,
    };
}

export function getReportPropertiesAction(filterQuery) {
    return (dispatch, getState) => {
        dispatch({ type: 'SET_PROPERTY_LOADING', payload: true });
        getReportProperties(filterQuery).then((response) => {
            dispatch(confirmedGetPropertiesAction(response.data.data));
        }).finally(() => {
            dispatch({ type: 'SET_PROPERTY_LOADING', payload: false });
        });
    };
}


